<ng-content select="[multiple-treatment]"></ng-content>
<table #_table>
  <thead>
    <ng-content select="[head]"></ng-content>
  </thead>
  <tbody>
    <ng-content select="[body]"></ng-content>
  </tbody>
  <tfoot>
    <ng-content select="[foot]"></ng-content>
  </tfoot>
</table>
